import React from "react";
import { useUscLabel } from "../../../../utils/labels";
import { useUscSelector } from "../../../../redux/store";
import Text from "../../styles/atoms/Text";
import * as Styles from "./HubBanner.styles";

const HubBanner = (): JSX.Element => {
    const model = useUscSelector((state) => state.vehicle.result?.product.model || "");

    const titleLabel = useUscLabel("uscPdpBannerHubTitle", { model });
    const descriptionLabel = useUscLabel("uscPdpBannerHubDescription", { model });

    return (
        <Styles.Wrapper>
            <Text tag="h2" variant="h4">
                {titleLabel}
            </Text>
            <Text variant="body-book">{descriptionLabel}</Text>
        </Styles.Wrapper>
    );
};

export default HubBanner;
